<div class="flex flex-col h-full w-full justify-start items-start bg-[#FFFFFF]">
  <app-stepper [linear]="true" class="w-full">
    <cdk-step [label]="'Modulauswahl'" [editable]="false" [completed]="false">
    </cdk-step>
    <cdk-step [label]="'Prüfregelauswahl'" [editable]="false" [completed]="false">
    </cdk-step>
    <cdk-step [label]="'Dateiauswahl'" [editable]="false" [completed]="false">
    </cdk-step>
    <cdk-step [label]="'Prüfergebnis'" [editable]="false" [completed]="false">
    </cdk-step>
  </app-stepper>

  <!-- Content Area -->
  <div class="flex flex-row h-full w-full justify-center items-start gap-6 p-6 overflow-hidden">

    <!-- HOAI Check Panel -->
    <div class="flex flex-col h-full w-1/2 justify-between items-start p-6 gap-6 rounded-lg border border-gray-200">
      <!-- HOAI Texts -->
      <div class="flex flex-col justify-start items-start w-full h-hug gap-6 overflow-hidden">
        <div class="flex flex-row justify-start items-start w-full h-hug text-lg text-green font-medium select-none">HOAI-Check</div>

        <div class="flex flex-col justify-start items-start w-full h-hug gap-6 overflow-y-auto">
          <!-- HOAI Main Text -->
          <div class="flex flex-col justify-start items-start w-full h-hug gap-5">
            <span class="w-full text-base text-green font-medium select-none">Automatisierte Prüfung von Planungsleistungen analog der HOAI</span>

            <!-- HOAI Bullet Points 1 -->
            <div class="flex flex-col w-full justify-start items-start">
              <span class="w-full text-sm text-gray font-medium">Strukturierte Prüfung Ihrer Planungsleistungen</span>
              @for (bulletPoint of hoaiBulletPoints1; track bulletPoint) {
                <div class="flex flex-row w-full justify-start items-start gap-2 pl-2">
                  <fa-icon [icon]="faCircleSmall" class="text-[8px] pt-[5px] text-gray"></fa-icon>
                  <span class="w-full text-sm text-gray font-normal">{{bulletPoint}}</span>
                </div>
              }
            </div>

            <!-- HOAI Bullet Points 2 -->
            <div class="flex flex-col w-full justify-start items-start">
              <span class="w-full text-sm text-gray font-medium">Umfassender Prüfbericht zu Ihren Planungsunterlagen</span>
              @for (bulletPoint of hoaiBulletPoints2; track bulletPoint) {
                <div class="flex flex-row w-full justify-start items-start gap-2 pl-2">
                  <fa-icon [icon]="faCircleSmall" class="text-[8px] pt-[5px] text-gray"></fa-icon>
                  <span class="w-full text-sm text-gray font-normal">{{bulletPoint}}</span>
                </div>
              }
            </div>
          </div> <!-- End HOAI Main Text -->

          <!-- HAOI Dropdown 1 -->
          <div class="flex flex-col w-full h-hug justify-start items-start gap-6">
            <div class="flex flex-row max-w-full justify-start items-start gap-2 py-2 hover:cursor-pointer" (click)="expandedHoaiInfo1 = !expandedHoaiInfo1">
              <fa-icon [icon]="faMemoCircleCheck" class="text-base text-gray"></fa-icon>
              <span class="w-full text-base text-gray font-medium select-none">Gebäude und Innenräume</span>
              <fa-icon [icon]="expandedHoaiInfo1 ? faChevronUp : faChevronDown" class="text-base text-gray"></fa-icon>
            </div>
            @if (expandedHoaiInfo1) {
              <div class="flex flex-col w-full justify-start items-start gap-4">
                <span class="w-full text-sm text-gray font-normal">Planungsleistungen für <span class="font-medium">Gebäude und Innenräume</span> – von der <span class="font-medium">Grundlagenermittlung</span> über die <span class="font-medium">Entwurfs- und Ausführungsplanung</span> bis hin zur <span class="font-medium">Objektbetreuung</span>.</span>

                <div class="flex flex-col justify-start items-start w-full h-hug">
                  <div class="flex flex-row w-full justify-start items-start gap-2 pl-2">
                    <fa-icon [icon]="faCircleSmall" class="text-[8px] pt-[5px] text-gray"></fa-icon>
                    <span class="w-full text-sm text-gray font-normal">Verfügbare Leistungsphasen: 1 bis 9</span>
                  </div>
                  <div class="flex flex-row w-full justify-start items-start gap-2 pl-2">
                    <fa-icon [icon]="faCircleSmall" class="text-[8px] pt-[5px] text-gray"></fa-icon>
                    <span
                      class="w-full text-[14px] text-gray">Individuelle Prüfung von Grund- und besonderen Leistungen</span>
                  </div>
                </div>
              </div>
            }
          </div>

          <!-- HAOI Dropdown 2 -->
          <div class="flex flex-col w-full h-hug justify-start items-start gap-6">
            <div class="flex flex-row max-w-full justify-start items-start py-2 gap-2 hover:cursor-pointer" (click)="expandedHoaiInfo2 = !expandedHoaiInfo2">
              <fa-icon [icon]="faMemoCircleCheck" class="text-base text-gray"></fa-icon>
              <span class="w-full text-base text-gray font-medium select-none">Technische Anlagen</span>
              <fa-icon [icon]="expandedHoaiInfo2 ? faChevronUp : faChevronDown" class="text-base text-gray"></fa-icon>
            </div>
            @if (expandedHoaiInfo2) {
              <div class="flex flex-col w-full justify-start items-start gap-4">
                <span class="w-full text-sm text-gray font-normal">Fachplanerische Leistungen für die <span class="font-medium">technische Gebäudeausrüstung</span>, z.B. Heizungs-, Lüftungs-, Sanitär- und Elektrotechnik – von der <span class="font-medium">Bedarfsermittlung</span> bis zur <span class="font-medium">Ausführungsplanung</span>.</span>

                <div class="flex flex-col justify-start items-start w-full h-hug">
                  <div class="flex flex-row w-full justify-start items-start gap-2 pl-2">
                    <fa-icon [icon]="faCircleSmall" class="text-[8px] pt-[5px] text-gray"></fa-icon>
                    <span class="w-full text-sm text-gray font-normal">Verfügbare Leistungsphasen: 1 bis 5</span>
                  </div>
                  <div class="flex flex-row w-full justify-start items-start gap-2 pl-2">
                    <fa-icon [icon]="faCircleSmall" class="text-[8px] pt-[5px] text-gray"></fa-icon>
                    <span
                      class="w-full text-[14px] text-gray">Individuelle Prüfung von Grund- und besonderen Leistungen</span>
                  </div>
                </div>
              </div>
            }
          </div>

        </div>
      </div> <!-- End HOAI Texts -->

      <!-- HOAI-Check Button -->
      <div class="flex flex-row w-full h-hug justify-center items-center">
        @if (permissionService.hasProjectPrivilege('PROJECT_CHECK_EXECUTE')) {
          <bic-button (click)="toHoai()" [disabled]="navigation.resolving">Zum Check<fa-icon iconRight [icon]="faChevronRight"></fa-icon></bic-button>
        } @else {
          <div [tooltip]="'Keine Berechtigung'" class="pointer-events-auto cursor-not-allowed inline-block">
            <bic-button [disabled]="true" class="pointer-events-none">Zum Check<fa-icon iconRight [icon]="faChevronRight"></fa-icon></bic-button>
          </div>
        }
      </div>
    </div> <!-- End HOAI Check Panel -->


    <!-- BIM/LOI Check Panel -->
    <div class="flex flex-col h-full w-1/2 justify-between items-start p-6 gap-6 rounded-lg border border-gray-200">
      <!-- BIM Texts -->
      <div class="flex flex-col justify-start items-start w-full h-hug gap-6 overflow-hidden">
        <div class="flex flex-row justify-start items-start w-full h-hug text-lg text-green font-medium select-none">LOIplus-Check</div>

        <div class="flex flex-col justify-start items-start w-full h-hug gap-6 overflow-y-auto">
          <!-- BIM Main Text -->
          <div class="flex flex-col justify-start items-start w-full h-hug gap-5">
            <span class="w-full text-base text-green font-medium select-none">Ganzheitliche Modellprüfung für IFC-Daten</span>

            <!-- BIM Bullet Points 1 -->
            <div class="flex flex-col w-full justify-start items-start">
              <span class="w-full text-sm text-gray font-medium">Individuelle Prüfung der Datenqualität von IFC-Dateien</span>
              @for (bulletPoint of bimBulletPoints1; track bulletPoint) {
                <div class="flex flex-row w-full justify-start items-start gap-2 pl-2">
                  <fa-icon [icon]="faCircleSmall" class="text-[8px] pt-[5px] text-gray"></fa-icon>
                  <span class="w-full text-sm text-gray font-normal">{{bulletPoint}}</span>
                </div>
              }
            </div>

            <!-- BIM Bullet Points 2 -->
            <div class="flex flex-col w-full justify-start items-start">
              <span class="w-full text-sm text-gray font-medium">Nahtlos integriert: Werkzeuge für effizientes Arbeiten mit IFC-Modellen</span>
              @for (bulletPoint of bimBulletPoints2; track bulletPoint) {
                <div class="flex flex-row w-full justify-start items-start gap-2 pl-2">
                  <fa-icon [icon]="faCircleSmall" class="text-[8px] pt-[5px] text-gray"></fa-icon>
                  <span class="w-full text-sm text-gray font-normal">{{bulletPoint}}</span>
                </div>
              }
            </div>
          </div> <!-- End BIM Main Text -->

          <!-- BIM Dropdown 1 -->
          <div class="flex flex-col w-full h-hug justify-start items-start gap-6">
            <div class="flex flex-row max-w-full justify-start items-start gap-2 py-2 hover:cursor-pointer" (click)="expandedBimInfo1 = !expandedBimInfo1">
              <fa-icon [icon]="faCube" class="text-base text-gray"></fa-icon>
              <span class="w-full text-base text-gray font-medium select-none">LOI-Check</span>
              <fa-icon [icon]="expandedBimInfo1 ? faChevronUp : faChevronDown" class="text-base text-gray"></fa-icon>
            </div>
            @if (expandedBimInfo1) {
              <div class="flex flex-col w-full justify-start items-start gap-4">
                <span class="w-full text-sm text-gray font-normal">Der LOI-Check <span class="font-medium">(Level of Information)</span> ermöglicht eine <span class="font-medium">personalisierbare, projektspezifische Überprüfung</span> des <span class="font-medium">Informationsgehalts</span> von IFC-Modellen.</span>

                <div class="flex flex-col justify-start items-start w-full h-hug">
                  @for (infoPoint of loiInfos; track infoPoint) {
                    <div class="flex flex-row w-full justify-start items-start gap-2 pl-2">
                      <fa-icon [icon]="faCircleSmall" class="text-[8px] pt-[5px] text-gray"></fa-icon>
                      <span class="w-full text-sm text-gray font-normal">{{infoPoint}}</span>
                    </div>
                  }
                </div>
              </div>
            }
          </div>

          <!-- BIM Dropdown 2 -->
          <div class="flex flex-col w-full h-hug justify-start items-start gap-6">
            <div class="flex flex-row max-w-full justify-start items-start py-2 gap-2 hover:cursor-pointer" (click)="expandedBimInfo2 = !expandedBimInfo2">
              <fa-icon [icon]="faCube" class="text-base text-gray"></fa-icon>
              <span class="w-full text-base text-gray font-medium select-none">BIM-Basis-Check </span>
              <fa-icon [icon]="expandedBimInfo2 ? faChevronUp : faChevronDown" class="text-base text-gray"></fa-icon>
            </div>
            @if (expandedBimInfo2) {
              <div class="flex flex-col w-full justify-start items-start gap-4">
                <span class="w-full text-sm text-gray font-normal">Überprüfung von IFC-Modellen auf Basis-Modelliervorgaben. Im BIM-Basis-Check werden formale Kriterien geprüft, um die Modellqualität zu sichern.</span>

                <div class="flex flex-col justify-start items-start w-full h-hug">
                  @for (bimInfo of bimBaseInfos; track bimInfo) {
                    <div class="flex flex-row w-full justify-start items-start gap-2 pl-2">
                      <fa-icon [icon]="faCircleInfo" [tooltip]="bimBaseTooltips[bimBaseInfos.indexOf(bimInfo)]" [tooltipDirection]="'top'" class="text-[12px] pt-[2px] text-gray-300"></fa-icon>
                      <span class="w-full text-sm text-gray font-normal">{{bimInfo}}</span>
                    </div>
                  }
                </div>
              </div>
            }
          </div>

        </div>
      </div> <!-- End BIM Texts -->

      <!-- LOIplus-Check Button -->
      <div class="flex flex-row w-full h-hug justify-center items-center">
        @if (permissionService.hasProjectPrivilege('PROJECT_CHECK_EXECUTE')) {
          <bic-button (click)="toLoi()" [disabled]="navigation.resolving">Zum Check<fa-icon iconRight [icon]="faChevronRight"></fa-icon></bic-button>
        } @else {
          <div [tooltip]="'Keine Berechtigung'" class="pointer-events-auto cursor-not-allowed inline-block">
            <bic-button [disabled]="true" class="pointer-events-none">Zum Check<fa-icon iconRight [icon]="faChevronRight"></fa-icon></bic-button>
          </div>
        }
      </div>
    </div> <!-- End LOIplus Check Panel -->

  </div> <!-- End Content Area -->
</div>
